export default __webpack_public_path__ + "static/media/rightarrow.3c168740.svg";